import VGSearch from "./search";
import {listener} from "../../../../../modules/vegas/js/util";
import {timeout} from "../../../vg/modules/timeout";

/** desktop */

let searchDesktop = new VGSearch();
searchDesktop.setContainer('#desktop-search-results')

listener('click', '#form-search-desktop [data-vg-toggle="search"]', function (el, e) {
	searchDesktop.toggle(el.value.length > 0);
	searchDesktop.search(el.value)
});

listener('input', '#form-search-desktop [data-vg-toggle="search"]', function (el, e) {
	searchDesktop.toggle(el.value.length > 0);

	timeout('desktop-search', 300, () => {
		searchDesktop.search(el.value)
	});
});

listener('click', '[data-vg-dismiss="search"]', (el, e) => {
	new VGSearch().close();
}, true);
